import { Action } from '@ngrx/store';
import {
  Contact,
  Column,
  ContactsData,
  ContactEventsData,
  Page,
  FilterItem,
  FilterTag,
  Deleter
} from './shared/models/Contact';
import * as moment from 'moment';

export const GET_DATA = 'GET_DATA';
export const GET_DATA_FAILURE = 'GET_DATA_FAILURE';
export const DELETE_DATA = 'DELETE_DATA';
export const SET_TAGS_FOR_SELECTED = 'SET_TAGS_FOR_SELECTED';
export const DELETE_CONTACT_TAG = 'DELETE_CONTACT_TAG';
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const GET_COLUMNS_FAILURE = 'GET_COLUMNS_FAILURE';
export const GET_COLUMNS_SUCCESS = 'GET_COLUMNS_SUCCESS';
export const GET_RAW_COLUMNS_FAILURE = 'GET_RAW_COLUMNS_FAILURE';
export const GET_RAW_COLUMNS_SUCCESS = 'GET_RAW_COLUMNS_SUCCESS';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const HIDE_EVENTS = 'HIDE_EVENTS';
export const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const USE_FILTERS = 'USE_FILTERS';
export const FILTER_BY_PROJECT = 'FILTER_BY_PROJECT';
export const SET_FILTER_TAGS = 'SET_FILTER_TAGS';
export const UPDATE_TEMP_TAG = 'UPDATE_TEMP_TAG';
export const ADD_TAG = 'ADD_TAG';
export const REMOVE_TAG = 'REMOVE_TAG';
export const GET_FILTER_USERS = 'GET_FILTER_USERS';
export const GET_FILTER_MY_NUMBERS = 'GET_FILTER_MY_NUMBERS';
export const GET_FILTER_MAIN_STATUSES = 'GET_FILTER_MAIN_STATUSES';
export const GET_FILTER_ITEMS_SUCCESS = 'GET_FILTER_ITEMS_SUCCESS';
export const GET_FILTER_ITEMS_FAILURE = 'GET_FILTER_ITEMS_FAILURE';
export const SET_FILTER_ITEMS_OPENED = 'SET_FILTER_ITEMS_OPENED';
export const SET_FILTERING_BY_ITEM = 'SET_FILTERING_BY_ITEM';
export const UPDATE_EDITED_FILTERS_LIST = 'UPDATE_EDITED_FILTERS_LIST';
export const UPDATE_TEMP_EDITED_FILTERS_LIST = 'UPDATE_TEMP_EDITED_FILTERS_LIST';
export const CLEAR_EDITED_FILTERS_LIST = 'CLEAR_EDITED_FILTERS_LIST';
export const REVERT_EDITED_FILTER_CHANGES = 'REVERT_EDITED_FILTER_CHANGES';
export const UPDATE_TEMP_PAGE_WITH_ITEMS = 'UPDATE_TEMP_PAGE_WITH_ITEMS';
export const TAKE_EDITING_FILTER_SNAPSHOT = 'TAKE_EDITING_FILTER_SNAPSHOT';
export const REMOVE_EXISTING_TAG_GROUP = 'REMOVE_EXISTING_TAG_GROUP';
export const OPEN_TOOLTIP_TAG_GROUP = 'OPEN_TOOLTIP_TAG_GROUP';
export const CLOSE_TOOLTIP_TAG_GROUP = 'CLOSE_TOOLTIP_TAG_GROUP';
export const CLEAR_TOOLTIP_TAG_GROUP = 'CLEAR_TOOLTIP_TAG_GROUP';
export const GET_FILTER_EVENT_TYPES = 'GET_FILTER_EVENT_TYPES';
export const GET_FILTER_BY_TAGS = 'GET_FILTER_BY_TAGS';
export const GET_FILTER_CALL_LENGTHS = 'GET_FILTER_CALL_LENGTHS';
export const SAVE_CALL_RANGE_FILTER_FORM = 'SAVE_CALL_RANGE_FILTER_FORM';
export const UPDATE_TEMP_FILTER_MAXDATA = 'UPDATE_TEMP_FILTER_MAXDATA';
export const RESET_STATE = 'RESET_STATE';
export const UPDATE_EXPANDED_LIST = 'UPDATE_EXPANDED_LIST';
export const SET_CALL_FINISH_TYPE_FILTER = 'SET_CALL_FINISH_TYPE_FILTER';
export const REMOVE_CALL_FINISH_TYPE_FILTER = 'REMOVE_CALL_FINISH_TYPE_FILTER';
export const TAKE_CALL_FINISH_TYPE_SNAPSHOT = 'TAKE_CALL_FINISH_TYPE_SNAPSHOT';
export const REVERT_CALL_FINISH_TYPE_SNAPSHOT = 'REVERT_CALL_FINISH_TYPE_SNAPSHOT';
export const TOGGLE_CONTACTS_TABLE = 'TOGGLE_CONTACTS_TABLE';
export const EDIT_SEARCH_PHRASE_ACTION = 'EDIT_SEARCH_PHRASE_ACTION';
export const SET_MASSIVE_OPTION_ACTION = 'SET_MASSIVE_OPTION_ACTION';
export const SET_EXCLUDED_CONTACTS_ACTION = 'SET_EXCLUDED_CONTACTS_ACTION';
export const TOGGLE_TAG_EDITOR_ACTION = 'TOGGLE_TAG_EDITOR_ACTION';
export const CLEAR_PAGE_OFFSET_ACTION = 'CLEAR_PAGE_OFFSET_ACTION';
export const SET_PAGE_OFFSET_ACTION = 'SET_PAGE_OFFSET_ACTION';

export class GetDataAction implements Action {
  readonly type = GET_DATA;

  constructor(public payload: { page: Page; offset: number }) {}
}

export class GetDataFailureAction implements Action {
  readonly type = GET_DATA_FAILURE;

  constructor(public payload: any) {}
}

export class DeleteDataAction implements Action {
  readonly type = DELETE_DATA;

  constructor(public payload: Deleter) {}
}

export class SetTagsForSelectedAction implements Action {
  readonly type = SET_TAGS_FOR_SELECTED;

  constructor(public payload: Deleter) {}
}

export class DeleteContactTagAction implements Action {
  readonly type = DELETE_CONTACT_TAG;

  constructor(public payload: Deleter) {}
}

export class GetContactsFailureAction implements Action {
  readonly type = GET_CONTACTS_FAILURE;

  constructor(public payload: any) {}
}

export class GetContactsSuccessAction implements Action {
  readonly type = GET_CONTACTS_SUCCESS;

  constructor(public payload: { data: ContactsData; page: Page }) {}
}

export class GetColumnsFailureAction implements Action {
  readonly type = GET_COLUMNS_FAILURE;

  constructor(public payload: any) {}
}

export class GetColumnsSuccessAction implements Action {
  readonly type = GET_COLUMNS_SUCCESS;

  constructor(public payload: { dataCol: Column[]; page: Page }) {}
}

export class GetRawColumnsFailureAction implements Action {
  readonly type = GET_RAW_COLUMNS_FAILURE;

  constructor(public payload: any) {}
}

export class GetRawColumnsSuccessAction implements Action {
  readonly type = GET_RAW_COLUMNS_SUCCESS;

  constructor(public payload: Column[]) {}
}

export class UpdateColumnsAction implements Action {
  readonly type = UPDATE_COLUMNS;

  constructor(public payload: Column[]) {}
}

export class GetEventsAction implements Action {
  readonly type = GET_EVENTS;

  constructor(public payload: any) {}
}

export class GetEventsFailureAction implements Action {
  readonly type = GET_EVENTS_FAILURE;

  constructor(public payload: any) {}
}

export class GetEventsSuccessAction implements Action {
  readonly type = GET_EVENTS_SUCCESS;

  constructor(public payload: ContactEventsData) {}
}

export class HideEventsAction implements Action {
  readonly type = HIDE_EVENTS;

  constructor(public payload: Contact) {}
}

export class OpenTagGroupTooltip implements Action {
  readonly type = OPEN_TOOLTIP_TAG_GROUP;

  constructor(public payload: string) {}
}

export class CloseTagGroupTooltip implements Action {
  readonly type = CLOSE_TOOLTIP_TAG_GROUP;

  constructor(public payload: string) {}
}

export class ClearTagGroupTooltip implements Action {
  readonly type = CLEAR_TOOLTIP_TAG_GROUP;

  constructor() {}
}

export class SetDateRangeAction implements Action {
  readonly type = SET_DATE_RANGE;

  constructor(public payload: { dateFrom: moment.Moment | string; dateTo: moment.Moment | string }) {}
}

export class ClearFilterAction implements Action {
  readonly type = CLEAR_FILTER;

  constructor() {}
}

export class UseGeneratedFilterAction implements Action {
  readonly type = USE_FILTERS;

  constructor() {}
}

export class SetFilteringByProjectAction implements Action {
  readonly type = FILTER_BY_PROJECT;
  constructor(public payload: number[]) {}
}

export class UpdateTempTagAction implements Action {
  readonly type = UPDATE_TEMP_TAG;
  constructor(public payload: { tags: FilterTag[]; source: string }) {}
}

export class AddTagAction implements Action {
  readonly type = ADD_TAG;
  constructor(public payload: FilterTag) {}
}

export class RemoveTagAction implements Action {
  readonly type = REMOVE_TAG;
  constructor(public payload: FilterTag) {}
}

export class SetFilterTagsAction implements Action {
  readonly type = SET_FILTER_TAGS;
  constructor() {}
}

export class GetFilterUsersAction implements Action {
  readonly type = GET_FILTER_USERS;
  constructor(public payload: string) {}
}

export class GetFilterMyNumbersAction implements Action {
  readonly type = GET_FILTER_MY_NUMBERS;
  constructor(public payload: string) {}
}

export class GetFilterMainStatusesAction implements Action {
  readonly type = GET_FILTER_MAIN_STATUSES;
  constructor(public payload: string) {}
}

export class GetFilterEventTypesAction implements Action {
  readonly type = GET_FILTER_EVENT_TYPES;
  constructor(public payload: string) {}
}

export class GetFilterByTagsAction implements Action {
  readonly type = GET_FILTER_BY_TAGS;
  constructor(public payload: string) {}
}

export class GetFilterCallLengthsAction implements Action {
  readonly type = GET_FILTER_CALL_LENGTHS;
  constructor(public payload: string) {}
}

export class GetFilterItemsSuccessAction implements Action {
  readonly type = GET_FILTER_ITEMS_SUCCESS;

  constructor(public payload: { list: FilterItem[]; filterName: string }) {}
}

export class GetFilterItemsFailureAction implements Action {
  readonly type = GET_FILTER_ITEMS_FAILURE;

  constructor(public payload: any) {}
}

export class SetFilterItemOpened implements Action {
  readonly type = SET_FILTER_ITEMS_OPENED;

  constructor(public payload: string) {}
}

export class SetFilteringByFilterItemAction implements Action {
  readonly type = SET_FILTERING_BY_ITEM;

  constructor(public payload: { collection: string[]; filter: string }) {}
}

export class UpdateTempEditedFilterList implements Action {
  readonly type = UPDATE_TEMP_EDITED_FILTERS_LIST;

  constructor(public payload: string[]) {}
}

export class UpdateEditedFilterList implements Action {
  readonly type = UPDATE_EDITED_FILTERS_LIST;

  constructor() {}
}

export class ClearEditedFilterList implements Action {
  readonly type = CLEAR_EDITED_FILTERS_LIST;

  constructor() {}
}

export class RevertEditedFilterChanges implements Action {
  readonly type = REVERT_EDITED_FILTER_CHANGES;

  constructor() {}
}

export class TakeEditingFilterSnapshot implements Action {
  readonly type = TAKE_EDITING_FILTER_SNAPSHOT;

  constructor() {}
}

export class UpdateTempPageWithItemsAction implements Action {
  readonly type = UPDATE_TEMP_PAGE_WITH_ITEMS;

  constructor(public payload: string) {}
}

export class RemoveExistingTagGroup implements Action {
  readonly type = REMOVE_EXISTING_TAG_GROUP;

  constructor(public payload: FilterTag) {}
}

export class SaveCallRangeFilterFormAction implements Action {
  readonly type = SAVE_CALL_RANGE_FILTER_FORM;

  constructor(public payload: any) {}
}

export class UpdateTempFilterMaxData implements Action {
  readonly type = UPDATE_TEMP_FILTER_MAXDATA;

  constructor(public payload: moment.Moment | string) {}
}

export class ResetState implements Action {
  readonly type = RESET_STATE;

  constructor() {}
}

export class UpdateExpandedList implements Action {
  readonly type = UPDATE_EXPANDED_LIST;

  constructor(public payload: number[]) {}
}

export class SetCallFinishTypeFilter implements Action {
  readonly type = SET_CALL_FINISH_TYPE_FILTER;

  constructor(public payload: string) {}
}

export class RemoveCallFinishTypeFilter implements Action {
  readonly type = REMOVE_CALL_FINISH_TYPE_FILTER;

  constructor(public payload: string) {}
}

export class TakeCallFinishTypeSnapshotAction implements Action {
  readonly type = TAKE_CALL_FINISH_TYPE_SNAPSHOT;

  constructor() {}
}

export class RevertCallFinishTypeSnapshotAction implements Action {
  readonly type = REVERT_CALL_FINISH_TYPE_SNAPSHOT;

  constructor() {}
}

export class ToggleContactsTableAction implements Action {
  readonly type = TOGGLE_CONTACTS_TABLE;

  constructor(public payload: boolean) {}
}

export class EditSearchPhraseAction implements Action {
  readonly type = EDIT_SEARCH_PHRASE_ACTION;

  constructor(public payload: string | null) {}
}

export class SetMassiveOptionAction implements Action {
  readonly type = SET_MASSIVE_OPTION_ACTION;

  constructor(public payload: boolean) {}
}

export class SetExcludedContactsAction implements Action {
  readonly type = SET_EXCLUDED_CONTACTS_ACTION;

  constructor(public payload: number[]) {}
}

export class ToggleTagEditorAction implements Action {
  readonly type = TOGGLE_TAG_EDITOR_ACTION;

  constructor(public payload: boolean) {}
}

export class ClearPageOffsetAction implements Action {
  readonly type = CLEAR_PAGE_OFFSET_ACTION;

  constructor(public payload: number) {}
}

export class SetPageOffsetAction implements Action {
  readonly type = SET_PAGE_OFFSET_ACTION;

  constructor(public payload: number) {}
}

export type ContactsAction =
  | GetDataAction
  | GetDataFailureAction
  | DeleteDataAction
  | SetTagsForSelectedAction
  | DeleteContactTagAction
  | GetContactsFailureAction
  | GetContactsSuccessAction
  | GetColumnsFailureAction
  | GetColumnsSuccessAction
  | GetRawColumnsFailureAction
  | GetRawColumnsSuccessAction
  | GetEventsAction
  | GetEventsFailureAction
  | GetEventsSuccessAction
  | HideEventsAction
  | UpdateColumnsAction
  | SetDateRangeAction
  | ClearFilterAction
  | UseGeneratedFilterAction
  | SetFilteringByProjectAction
  | SetFilterTagsAction
  | UpdateTempTagAction
  | AddTagAction
  | RemoveTagAction
  | GetFilterUsersAction
  | GetFilterMyNumbersAction
  | GetFilterMainStatusesAction
  | GetFilterCallLengthsAction
  | GetFilterItemsSuccessAction
  | GetFilterItemsFailureAction
  | SetFilterItemOpened
  | SetFilteringByFilterItemAction
  | UpdateEditedFilterList
  | ClearEditedFilterList
  | RevertEditedFilterChanges
  | UpdateTempEditedFilterList
  | TakeEditingFilterSnapshot
  | UpdateTempPageWithItemsAction
  | RemoveExistingTagGroup
  | OpenTagGroupTooltip
  | CloseTagGroupTooltip
  | ClearTagGroupTooltip
  | GetFilterEventTypesAction
  | GetFilterByTagsAction
  | SaveCallRangeFilterFormAction
  | UpdateTempFilterMaxData
  | ResetState
  | UpdateExpandedList
  | SetCallFinishTypeFilter
  | RemoveCallFinishTypeFilter
  | TakeCallFinishTypeSnapshotAction
  | RevertCallFinishTypeSnapshotAction
  | ToggleContactsTableAction
  | EditSearchPhraseAction
  | SetMassiveOptionAction
  | SetExcludedContactsAction
  | ToggleTagEditorAction
  | ClearPageOffsetAction
  | SetPageOffsetAction;
